import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник для работы с ролями пользователей.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2" }, " Каждая роль содержит набор из заранее заданных в системе полномочий. В зависимости от полномочий, пользователям доступны те или иные функции системы. Установить роль пользователю можно в справочнике Пользователи. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Роли",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}